module.exports = __webpack_public_path__ + "static/media/rb_th.73f9ed7d.png";